<template lang="html">
  <div class="options">
    <div v-for="o in options" class="option" @mouseenter="showImage(o.id)" @mouseleave="hideImage()">
      <transition name="fade">
        <div class="option-image" v-if="show && showId === o.id"><img :src="o.image"></div>
      </transition>
      {{o.name}} ({{o.price}}€)
      <select @change="setPrice(o.id, $event)" class="options_options">
        <option value="0">0</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
    </div>
  </div>
</template>

<script>
import {options} from '../../assets/configuration.js'

export default {
  data () {
    return {
      show: false,
      showId: 0,
      options,
      prices: [
        {id: 0, price: 0, quantity: 0},
        {id: 1, price: 0, quantity: 0},
        {id: 2, price: 0, quantity: 0},
        {id: 3, price: 0, quantity: 0},
        {id: 4, price: 0, quantity: 0},
        {id: 5, price: 0, quantity: 0},
        {id: 6, price: 0, quantity: 0},
        {id: 7, price: 0, quantity: 0}
      ]
    }
  },
  methods: {
    showImage (id) {
      this.show = true
      this.showId = id
    },
    hideImage (id) {
      this.show = false
    },
    setPrice (id, e) {
      var p = this.options[id].price * parseInt(e.target.value)
      if (this.prices[id].price !== p) {
        this.$store.commit('subPrice', this.prices[id].price)
        this.$store.commit('addPrice', p)
        this.prices[id].price = p
        this.prices[id].quantity = parseInt(e.target.value)
      }
      this.setDevis()
    },
    setDevis () {
      this.$store.commit('setDevis', {id: 4, set: {options: this.prices}})
    }
  }
}
</script>

<style lang="css" scoped>
select.options_options {
  padding: 0 0 0 11px;
}
.options {
  color: #FFF;
  position: relative;
  font-weight: bold;
}
.option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.option-image {
  padding: 10px;
  border: 1px solid #08c7fe;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 90px;
  position:absolute;
  background: #FFF;
  margin-left: -130px;
  z-index: 400;
}
.option-image img {
  max-width: 100%;
}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
  transform: translateX(0);
  transition: all .2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(-25px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Options.vue?e6727cea